import React, { useEffect, useRef } from 'react';
import MessageRenderer from './MessageRenderer';
import TypingIndicator from './TypingIndicator';

function ChatView({
  messages,
  isAgentTyping,
  assignedAgent,
  buttonReplyAnswer,
  selectedColor,
  textColor
}) {
  const messagesEndRef = useRef(null);
  const assignedAgentAvailable = () => assignedAgent?.status === 'available';
  const handleButtonReplyClick = (buttonName) => {
    buttonReplyAnswer(buttonName);
  };

  useEffect(() => {
    // Scroll to the bottom every time messages change
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="chat-view flex flex-col overflow-hidden relative h-full flex-grow">
      <div
        className="chat-header min-h-[70px] relative z-99 p-5 px-6 bg-gradient-to-r hover:opacity-80 flex flex-row items-center justify-between"
        style={{ backgroundColor: selectedColor }}
      >
        {assignedAgent && (
          <>
            <div className="flex gap-2">
              {assignedAgent.name !== 'Bot' && (
                <>
                  <div
                    className="w-8 h-8 rounded-full border-2 border-white"
                    style={{
                      backgroundImage: `url(${assignedAgent.avatar})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover'
                    }}
                  ></div>
                  <h2 className={`${textColor.token} font-bold text-xl`}>
                    {assignedAgent.name}
                  </h2>
                </>
              )}
            </div>
            <div className="rounded-full bg-white px-4 py-2 text-xs flex justify-end items-center shadow-xl">
              <span
                className={`h-2 w-2 ${
                  assignedAgentAvailable() ? 'bg-callbell-green' : 'bg-gray-300'
                } rounded-full mr-2`}
              ></span>
              <p className="font-bold">{assignedAgentAvailable() ? 'Online' : 'Away'}</p>
            </div>
          </>
        )}
      </div>
      {/* Conversation Area */}
      <div className="conversation h-auto flex-grow p-5 overflow-hidden overflow-y-scroll">
        {messages.map((message, index) => (
          <MessageRenderer
            key={index}
            message={message}
            handleButtonReplyClick={(buttonName) => handleButtonReplyClick(buttonName)}
            selectedColor={selectedColor}
            textColor={textColor}
          />
        ))}
        {isAgentTyping && <TypingIndicator />}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}

export default ChatView;
